<template>
    <div>
        <Modal
            v-model="preViewModal.show"
            :width="1000"
            title="预览发票"
            class="invoice-preview-modal"
        >
            <div class="invoice-container">
                <div class="header-row">
                    <div class="w-330"></div>
                    <div class="invoice-title">
                        {{ isDigital ? "（电子发票）" : "" }}增值税虚拟发票
                    </div>
                    <div class="w-330 text-right">
                        <span>开票日期:</span>
                        <span class="text-black ml-4">{{ currentDate }}</span>
                    </div>
                </div>

                <div class="info-box-wrapper">
                    <div class="flex-center">
                        <div class="vertical-text invoiceBorder side-label">
                            {{ isDigital ? "购买方信息" : "购买方" }}
                        </div>
                        <div class="invoiceBorder info-content">
                            <div>
                                <span class="label-justify"
                                    >名&emsp;&emsp;&emsp;&emsp;称:</span
                                ><span class="text-black ml-4">{{ preViewModal.invoiceModel.invoiceBuyerName }}</span>
                            </div>
                            <div>
                                <span>纳税人识别号:</span>
                                <span class="text-black ml-4">{{ preViewModal.invoiceModel.invoiceBuyerTaxNum }}</span>
                            </div>
                            <template v-if="!isDigital">
                                <div>
                                    <span>地址&emsp;、电话:</span>
                                    <span class="text-black ml-4">
                                        {{ preViewModal.invoiceModel.invoiceBuyerAddress }}
                                        {{ preViewModal.invoiceModel.invoiceBuyerTel }}
                                    </span>
                                </div>
                                <div>
                                    <span>开户行及账号:</span>
                                    <span class="text-black ml-4">
                                        {{ preViewModal.invoiceModel.invoiceBuyerBank }}
                                        {{ preViewModal.invoiceModel.invoiceBuyerAccount }}
                                    </span>
                                </div>
                            </template>
                        </div>

                        <div class="vertical-text invoiceBorder side-label">
                            {{ isDigital ? "销售方信息" : "密码区" }}
                        </div>
                        <div class="invoiceBorder info-content">
                            <template v-if="isDigital">
                                <div>
                                    <span class="label-justify"
                                        >名&emsp;&emsp;&emsp;&emsp;称:</span
                                    >
                                    <span class="text-black ml-4">{{
                                        companyName
                                    }}</span>
                                </div>
                                <div>
                                    <span>纳税人识别号:</span>
                                    <span class="text-black ml-4">{{
                                        preViewModal.salerTaxNum
                                    }}</span>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>

                <div v-if="!isDigital" class="info-box-wrapper border-top-0">
                    <div class="flex-center">
                        <div class="vertical-text invoiceBorder side-label">
                            销售方
                        </div>
                        <div class="invoiceBorder info-content">
                            <div>
                                <span class="label-justify"
                                    >名&emsp;&emsp;&emsp;&emsp;称:</span
                                >
                                <span class="text-black ml-4">{{
                                    companyName
                                }}</span>
                            </div>
                            <div>
                                <span>纳税人识别号:</span>
                                <span class="text-black ml-4">{{
                                    preViewModal.salerTaxNum
                                }}</span>
                            </div>
                            <div>
                                <span>地址&emsp;、电话:</span>
                                <span class="text-black ml-4">{{
                                    preViewModal.salerAddress
                                }}</span>
                            </div>
                            <div>
                                <span>开户行及账号:</span>
                                <span class="text-black ml-4">{{
                                    preViewModal.bankInfo
                                }}</span>
                            </div>
                        </div>
                        <div class="vertical-text invoiceBorder side-label">
                            备注
                        </div>
                        <div class="invoiceBorder info-content"></div>
                    </div>
                </div>

                <div class="table-row table-header">
                    <div class="invoiceBorder cell-name">项目名称</div>
                    <div class="invoiceBorder cell-std">规格型号</div>
                    <div class="invoiceBorder cell-std">单位</div>
                    <div class="invoiceBorder cell-std">数量</div>
                    <div class="invoiceBorder cell-std">单价</div>
                    <div class="invoiceBorder cell-std">金额</div>
                    <div class="invoiceBorder cell-std">税率</div>
                    <div class="invoiceBorder cell-std">税额</div>
                </div>

                <div
                    v-for="(item, index) in preViewModal.productList"
                    :key="index"
                    class="table-row text-black"
                >
                    <div class="invoiceBorder cell-name">
                        {{ item.productName }}
                    </div>
                    <div class="invoiceBorder cell-std">
                        {{ item.productSpec }}
                    </div>
                    <div class="invoiceBorder cell-std">{{ item.unit }}</div>
                    <div class="invoiceBorder cell-std">
                        {{ item.quantity }}
                    </div>
                    <div class="invoiceBorder cell-std">
                        {{ numberToFixed(item.price, 4) }}
                    </div>
                    <div class="invoiceBorder cell-std">
                        {{ numberToFixed(item.value, 4) }}
                    </div>
                    <div class="invoiceBorder cell-std">
                        {{ item.taxRate * 100 }}%
                    </div>
                    <div class="invoiceBorder cell-std">
                        {{ numberToFixed(item.taxValue, 4) }}
                    </div>
                </div>

                <div class="table-row text-black">
                    <div class="invoiceBorder cell-name text-theme">合计</div>
                    <div class="invoiceBorder cell-std"></div>
                    <div class="invoiceBorder cell-std"></div>
                    <div class="invoiceBorder cell-std"></div>
                    <div class="invoiceBorder cell-std"></div>
                    <div class="invoiceBorder cell-std">
                        {{ numberToFixed(preViewModal.totalValue, 4) }}
                    </div>
                    <div class="invoiceBorder cell-std"></div>
                    <div class="invoiceBorder cell-std">
                        {{ numberToFixed(preViewModal.totalTax, 4) }}
                    </div>
                </div>

                <div class="table-row text-black">
                    <div class="invoiceBorder cell-name text-theme">
                        价税合计(大写)
                    </div>
                    <div class="invoiceBorder cell-total-lg flex-between">
                        <span>{{
                            smalltoBIG(preViewModal.invoiceModel.invoiceValue)
                        }}</span>
                        <div>
                            <span class="text-theme">（小写）</span>
                            <span
                                >￥{{
                                    numberToFixed(
                                        preViewModal.invoiceModel.invoiceValue,
                                        2
                                    )
                                }}</span
                            >
                        </div>
                    </div>
                </div>

                <div v-if="isDigital" class="info-box-wrapper border-top-0">
                    <div class="flex-center">
                        <div class="vertical-text invoiceBorder side-label">
                            备注
                        </div>
                        <div class="invoiceBorder cell-remark-wide"></div>
                    </div>
                </div>

                <div class="footer-row">
                    <template v-if="isDigital">
                        <div class="w-250">
                            <span>开票人:</span>
                            <span class="text-black ml-4">{{
                                preViewModal.clerk
                            }}</span>
                        </div>
                    </template>
                    <template v-else>
                        <div class="w-250">
                            <span>收款人:</span>
                            <span class="text-black ml-4">{{
                                preViewModal.payee
                            }}</span>
                        </div>
                        <div class="w-250">
                            <span>复核:</span>
                            <span class="text-black ml-4">{{
                                preViewModal.checker
                            }}</span>
                        </div>
                        <div class="w-250">
                            <span>开票人:</span>
                            <span class="text-black ml-4">{{
                                preViewModal.clerk
                            }}</span>
                        </div>
                        <div class="w-250">
                            <span>销售方:</span>
                            <span>（章）</span>
                        </div>
                    </template>
                </div>
            </div>

            <div slot="footer">
                <Button
                    :loading="preViewModal.loading"
                    type="primary"
                    @click="onConfirmApplyInvoice"
                    >提交开票</Button
                >
            </div>
        </Modal>
    </div>
</template>

<script>
import { numberToFixed, smalltoBIG } from "@/components/number-input/display-format";
import { submitInvoice } from "@/api/modules/finance-management/invoice";

const COMPANY_NAME = "广州缤纷园艺有限公司";

export default {
    name: "InvoicePreviewModal",
    data() {
        return {
            companyName: COMPANY_NAME,
            preViewModal: {
                show: false,
                loading: false,
                invoiceModel: {},
                productList: [],
                clerk: "",
                payee: "",
                checker: "",
                salerTaxNum: "",
                salerTel: "",
                bankInfo: "",
                salerAddress: "",
                totalValue: 0,
                totalTax: 0
            }
        };
    },
    computed: {
        isDigital() {
            const line1 = this.preViewModal.invoiceModel.invoiceLine1 || "";
            return line1.indexOf("数电") >= 0;
        },
        currentDate() {
            const now = new Date();
            const year = now.getFullYear();
            const month = (now.getMonth() + 1).toString().padStart(2, "0");
            const date = now.getDate().toString().padStart(2, "0");
            return `${year}年${month}月${date}日`;
        }
    },
    methods: {
        numberToFixed,
        smalltoBIG,
        showModal(data) {
            console.log("data", data);
            Object.assign(this.preViewModal, data);

            // 使用 reduce 简化求和逻辑
            this.preViewModal.totalValue = this.preViewModal.productList.reduce(
                (acc, cur) => acc + cur.value,
                0
            );
            this.preViewModal.totalTax = this.preViewModal.productList.reduce(
                (acc, cur) => acc + cur.taxValue,
                0
            );

            this.preViewModal.show = true;
            console.log(this.preViewModal);
        },
        onConfirmApplyInvoice() {
            this.preViewModal.loading = true;
            const { invoiceUuid } = this.preViewModal.invoiceModel;

            submitInvoice({ invoiceUuid })
                .then((res) => {
                    this.preViewModal.loading = false;
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: "提示",
                            content: "提交成功"
                        });
                        this.preViewModal.show = false;
                        this.$emit('invoice-submitted');
                    }
                    else {
                        this.$emit('invoice-submit-error');
                    }
                })
                .catch((error) => {
                    this.preViewModal.loading = false;
                    this.$Message.error('提交开票失败');
                    this.$emit('invoice-submit-error');
                });
        }
    }
};
</script>

<style scoped>
/* 通用样式 */
.text-black {
    color: black;
}
.text-theme {
    color: rgb(241, 115, 72);
}
.text-right {
    text-align: right;
}
.ml-4 {
    margin-left: 4px;
}
.flex-center {
    display: flex;
    align-items: center;
}
.flex-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

/* 容器样式 */
.invoice-container {
    color: rgb(241, 115, 72);
    font-size: 14px;
}

/* 头部 */
.header-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.invoice-title {
    font-size: 24px;
    width: 330px;
    text-align: center;
}
.w-330 {
    width: 330px;
}

/* 信息框 (表格上半部分) */
.info-box-wrapper {
    border-top: 0.5px solid black;
    border-left: 0.5px solid black;
    margin-top: 10px;
}
.info-box-wrapper.border-top-0 {
    border-top: none; /* 去掉重复的上边框 */
    margin-top: 0;
}

.vertical-text {
    -webkit-writing-mode: vertical-rl;
    writing-mode: vertical-rl;
    text-align: center;
    line-height: 2;
}

.invoiceBorder {
    border-right: 0.5px solid black;
    border-bottom: 0.5px solid black;
}

/* 侧边标签栏 (购买方/密码区) */
.side-label {
    width: 30px;
    height: 90px;
}

/* 详细信息内容区 */
.info-content {
    width: 470px;
    height: 90px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-left: 4px;
}

/* 底部大备注区 */
.cell-remark-wide {
    width: 950px;
    height: 90px;
}

/* 列表表格区 */
.table-row {
    display: flex;
    line-height: 2;
    border-left: 0.5px solid black;
}
.table-header {
    /* 默认保持继承 */
}

/* 单元格宽度定义 */
.cell-name {
    width: 300px;
    height: 30px;
    text-align: center;
}
.cell-std {
    width: 100px;
    height: 30px;
    text-align: center;
}
.cell-total-lg {
    width: 700px;
    height: 30px;
    padding: 0 30px;
}

/* 底部页脚 */
.footer-row {
    display: flex;
    justify-content: space-between;
    margin-top: 4px;
}
.w-250 {
    width: 250px;
}
</style>
